import { UserAccessLevelGroupName } from '../enums/user-access-level-group-name.enum';
import { UserAccessLevelGroup } from '../models/user-access-level-group.model';
import { UserLevel } from 'src/modules/security/enums/user-level.enum';

export const accessLevelGroups: UserAccessLevelGroup = {
  [UserAccessLevelGroupName.ManifestAccessLevelGroup]: [UserLevel.PracticeAdmin, UserLevel.FullCareEvolveAccess, UserLevel.OrdersOnly],
  [UserAccessLevelGroupName.ResultsAccessLevelGroup]: [UserLevel.PracticeAdmin, UserLevel.FullCareEvolveAccess, UserLevel.ResultsOnly],
  [UserAccessLevelGroupName.OrdersAccessLevelGroup]: [UserLevel.PracticeAdmin, UserLevel.FullCareEvolveAccess, UserLevel.OrdersOnly],
  [UserAccessLevelGroupName.AdminAccessLevelGroup]: [UserLevel.PracticeAdmin]
};
